export default "/_next/static/images/78938e0b6d655f2518d1064aeff23a2c.jpg";